import React, { createContext, useState } from "react";

const SidebarContext = createContext();

const SidebarContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const handleChangeOpenSidebar = (value) => {
    if (typeof value !== "boolean") return;

    setOpen(value);
    sessionStorage.setItem("sidebarOpen", value);
  };

  return (
    <SidebarContext.Provider
      value={{
        handleChangeOpenSidebar,
        openSidebar: open,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export { SidebarContextProvider, SidebarContext };
